import { yardFromConfirmation, parkingYardMapsUrl } from "./parkingYardSearch";

function LocationLink({ yard }) {
  const href = parkingYardMapsUrl(yard);
  if (!href) return null;
  return (
    <a className="inv-yard-maps" href={href} target="_blank" rel="noopener noreferrer">
      View on Map
    </a>
  );
}

export default function ParkingYardSavedDetails({ confirmation, title = "Parking Yard" }) {
  const yard = yardFromConfirmation(confirmation);
  if (!yard) return null;

  return (
    <div className="inv-yard-selected inv-yard-saved-card">
      <p className="inv-yard-selected__label">{title}</p>
      <div className="inv-yard-card__name">{yard.name || "—"}</div>
      {yard.area ? <div className="inv-yard-meta">{yard.area}</div> : null}
      <div className="inv-yard-card__row">
        <span>Address</span>
        <strong>{yard.address || "—"}</strong>
      </div>
      <div className="inv-yard-card__row">
        <span>Area</span>
        <strong>{yard.area || "—"}</strong>
      </div>
      <div className="inv-yard-card__row">
        <span>PIN</span>
        <strong>{yard.pincode || "—"}</strong>
      </div>
      <div className="inv-yard-card__row">
        <span>Owner Name</span>
        <strong>{yard.ownerName || "—"}</strong>
      </div>
      <div className="inv-yard-card__row">
        <span>Owner Mobile No</span>
        <strong>{yard.ownerMobile || yard.phone || "—"}</strong>
      </div>
      <div className="inv-yard-card__row">
        <span>Manager Name</span>
        <strong>{yard.managerName || "—"}</strong>
      </div>
      <div className="inv-yard-card__row">
        <span>Manager Mobile No</span>
        <strong>{yard.managerPhone || yard.managerMobile || "—"}</strong>
      </div>
      <div className="inv-yard-card__row">
        <span>Location</span>
        <LocationLink yard={yard} />
      </div>
    </div>
  );
}
